"use client";
import PropTypes from "prop-types";

import {
  ImmadiateDeliveryIcon,
  PartialPaymentIcon,
  DeprecationIcon,
  RateIcon,
  CashIcon,
  InstalmentIcon,
  InterestIcon,
  DelayIcon,
  DepletableIcon,
} from "assets/svg/campaigns";

import styles from "./styles.module.css";

const Campaigns = ({ data }) => {
  const { companyCampaigns } = data.detailData?.[0]?.company || {};

  const SelectedCompanyCampaigns = (campaigns) => {
    const textItem = {
      DELAY: { text: "Aya Kadar vade", icon: <DelayIcon /> },
      INSTALMENT: { text: "Ay Taksit", icon: <InstalmentIcon /> },
      DEPLETABLE: { text: "Tükenmek Üzere", icon: <DepletableIcon /> },
      CASH: { text: "Peşinat", icon: <CashIcon /> },
      INTEREST: { text: "Faiz", icon: <InterestIcon /> },
      PARTIAL_PAYMENT: { text: "Ara Ödemeli", icon: <PartialPaymentIcon /> },
      RATE: { text: "Oran", icon: <RateIcon /> },
      IMMEDIATE_DELIVERY: { text: "Hemen Teslim", icon: <ImmadiateDeliveryIcon /> },
      DEPRECIATION: { text: "Yılda Amortisman", icon: <DeprecationIcon /> },
    };

    const isPercentage = (name) => (name === "INTEREST" || name === "CASH" ? <span> %</span> : null);

    return campaigns
      .filter((campaign) => campaign.date !== null)
      .sort((a, b) => new Date(a.date) - new Date(b.date))
      .slice(0, 3)
      .map((campaign, index) => (
        <span key={index} className={styles.campaignBox}>
          <b>
            {textItem[campaign.name]?.icon}
            <div className={styles.campaignTitle}>
              {isPercentage(campaign.name)}
              {campaign.campaignTitle} {textItem[campaign.name]?.text}
            </div>
          </b>
          <p className={styles.campaignDesc}>{campaign.description}</p>
        </span>
      ));
  };

  return (
    <div className={styles.wrapper}>
      <h1 className={styles.title}>Kampanyalar</h1>
      <div className={styles.campaignBoxWrapper}>{SelectedCompanyCampaigns(companyCampaigns)}</div>
    </div>
  );
};

Campaigns.propTypes = {
  data: PropTypes.object,
};
export default Campaigns;
